import React from 'react';
import PropTypes from 'prop-types';
import { isBOrVMRetail, isVMBusiness } from '../../utils/BrandUtils';

function FaqAnyQuestionsLink(props) {
  return (
    <div>
      {isBOrVMRetail() || isVMBusiness() ? (
        <a
          href={
            isVMBusiness()
              ? props.content.anyQuestionsFaqSMELink
              : props.content.anyQuestionsFaqLink
          }
          target="_blank"
          rel="noreferrer noopener"
        >
          {props.content.statementPreferenceGotAccountInfoLink2 +
            '(opens in a new window)'}
        </a>
      ) : (
        <a href="javascript:;" onClick={props.onClick}>
          {props.content.statementPreferenceGotAccountInfoLink2}
        </a>
      )}
    </div>
  );
}

FaqAnyQuestionsLink.propTypes = {
  data: PropTypes.any,
  content: PropTypes.any,
  onClick: PropTypes.func,
};

export default FaqAnyQuestionsLink;
